import React from "react";
import {
    Box,
    Checkbox,
    FormControlLabel,
    FormGroup,
    IconButton,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import styled from "styled-components";
import WorkingHoursInfo from "src/scenes/profile/working-hours-info";
import { Save } from "@mui/icons-material";
import request from "src/utils/request";

const SectionTitle = styled.h2`
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    padding: 0;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const CardContainer = styled(Paper)`
    border-radius: 14px;
    border: ${({ theme, result }) => {
        if (result === "pending") return `2px solid ${theme.palette.text.disabled}`;
        if (result === "success") return `2px solid ${theme.palette.success.main}`;
        if (result === "failure") return `2px solid ${theme.palette.error.main}`;
        return `2px solid transparent`;
    }};
`;

const SubText = styled(Typography)`
    font-size: 12px;
    color: ${({ theme }) => theme.palette.text.disabled};
`;

const SectionTitleIcon = styled(Stack)`
    height: 22px;
    width: 22px;
    background: ${({ theme }) => theme.palette.background.paper};
    border-radius: 2px;
`;

const WorkingHoursInfoCard = ({ user, updateUser }) => {
    const workingDays = user.workingHours;
    const [isWorkingHoursEnabled, setIsWorkingHoursEnabled] = React.useState(
        user && user.workingHours && user.workingHours.enabled
    );
    const [changes, setChanges] = React.useState("");
    const [saveResult, setSaveResult] = React.useState();

    const handleSetWorkingHours = () => {
        setIsWorkingHoursEnabled(!isWorkingHoursEnabled);
        setChanges({ enabled: !isWorkingHoursEnabled });
    };

    const hasChanges = () => !!Object.keys(changes).find(() => !!changes);

    React.useEffect(() => {
        setTimeout(() => {
            if (saveResult === "success" || saveResult === "failure") setSaveResult(undefined);
        }, 500);
    }, [saveResult]);

    const MakeResponse = () => {
        if (changes && changes.enabled === false) return changes;
        const join = { ...workingDays, ...changes };
        Object.keys(join).forEach((key) => {
            if (!join[key]) {
                return delete join[key];
            }
            if (!join[key]?.from && typeof join[key] === "object") {
                return delete join[key];
            }
            if (!join[key]?.to && typeof join[key] === "object") {
                return delete join[key];
            }
            return null;
        });
        return join;
    };

    const saveHandler = async () => {
        setSaveResult("pending");
        try {
            await request("/api/users/me", {
                method: "POST",
                body: `{"workingHours":${JSON.stringify(MakeResponse())}}`,
            });
            await updateUser();
            setChanges("");
            setSaveResult("success");
        } catch (e) {
            setSaveResult("failure");
        }
    };

    return (
        <>
            <Stack direction="row" justifyContent="space-between" pl={2} pr={2} pt={2} pb={1}>
                <SectionTitle>Set Working Hours</SectionTitle>
                {hasChanges() && (
                    <SectionTitleIcon direction="row" justifyContent="center" alignItems="center">
                        <IconButton onClick={saveHandler}>
                            <Save color="secondary" fontSize="small" />
                        </IconButton>
                    </SectionTitleIcon>
                )}
            </Stack>
            <CardContainer result={saveResult}>
                <Box p={4} pt={2}>
                    <Stack direction="column" mb={2} style={{ height: "100%" }}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isWorkingHoursEnabled}
                                        onChange={handleSetWorkingHours}
                                    />
                                }
                                label="Enable working hours"
                            />
                            <SubText>
                                By enabling working hours adadot will optimize metrics on your
                                selected days and hours.
                            </SubText>
                        </FormGroup>
                        {isWorkingHoursEnabled && (
                            <WorkingHoursInfo
                                workingDays={workingDays}
                                enabled={isWorkingHoursEnabled}
                                changes={changes}
                                setChanges={setChanges}
                            />
                        )}
                    </Stack>
                </Box>
            </CardContainer>
        </>
    );
};

export default WorkingHoursInfoCard;
